import {
    UPDATE_CAR_BLOCK_START,
    UPDATE_CAR_BLOCK_SUCCESS,
    UPDATE_CAR_BLOCK_ERROR,
} from '../../constants';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { updateFindYourBlock as mutation, getFindYourVehicleBlockQuery } from '../../lib/graphql';

export const manageFindYourVehicleBlock = (values) => {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({ type: UPDATE_CAR_BLOCK_START });
            const dynamicFindYourVehicleBlock = values?.dynamicFindYourVehicleBlock?.length > 0 ? JSON.stringify(values.dynamicFindYourVehicleBlock) : JSON.stringify([]);
            const defaultData = values?.dynamicFindYourVehicleBlock?.[0] || {};

            const { data } = await client.mutate({
                mutation,
                variables: {
                    ...values,
                    heading: defaultData?.heading,
                    buttonLabel: defaultData?.buttonLabel,
                    content1: defaultData?.content1,
                    content2: defaultData?.content2,
                    content3: defaultData?.content3,
                    content4: defaultData?.content4 || null,
                    content5: defaultData?.content5 || null,
                    dynamicFindYourVehicleBlock
                },
                refetchQueries: [{ query: getFindYourVehicleBlockQuery }]
            });

            if (data?.updateFindYourBlock?.status === 200) {
                showToaster({ messageId: 'updateFindYourBlock', toasterType: 'success' })
                dispatch({ type: UPDATE_CAR_BLOCK_SUCCESS });
            } else {
                dispatch({
                    type: UPDATE_CAR_BLOCK_ERROR,
                    payload: {
                        status: data?.updateFindYourBlock?.status
                    }
                });
            }
        } catch (error) {
            dispatch({
                type: UPDATE_CAR_BLOCK_ERROR,
                payload: {
                    error
                }
            });
        }
    };
}